import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ImproveService } from 'src/app/appServices/ImproveService/improve.service';
import { drawDOM, exportPDF, Group } from '@progress/kendo-drawing';
import { saveAs } from "@progress/kendo-file-saver";

@Component({
  selector: 'app-report-template',
  templateUrl: './report-template.component.html',
  styleUrls: ['./report-template.component.scss']
})
export class ReportTemplateComponent implements OnInit {
  @ViewChild('reportData') reportData: any = ElementRef;
  bodyFacilityImprovefacilityList:any = [];
  graphImages: any = [];
  base64Image: any = [];
  
  basicData: any;
  basicOptions: any
  headingSummaryOportunity: any;
  improveAHAAHASFL: any = [];
  improveAHAAHASFL2: any;
  activationToNeedleArray: any;
  improveAData: any;
  improveAAData: any;
  improveNData: any;
  improveATData: any;
  improveTAMHATS: any;
  activationTimeListQualifyCountEMS: any;
  activationTimeListQualifyCountTriage: any;
  WorkFlowTypePercentage: any;
  assessmentTimeListQualifyCountEMS: any;
  assessmentTimeListQualifyCountTriage: any;
  thrombolyticDecisionTimeListQualifyCountEMS: any;
  thrombolyticDecisionTimeListQualifyCountTriage: any;
  thrombolyticAdministrationTimeListQualifyCountEMS: any;
  thrombolyticAdministrationTimeListQualifyCountTriage: any;
  cumulativeYear: any;
  pastcumulativeYear: any;
  qti_accomplishments_improvements: any;
  qti_opportunities_pi_projects: any;
  selectedOptionText: any;
  monthYear: any;
  selectedFilterType: any;
  quarterYearForLabel: any;
  quarterYearForPreviousLabel: any;
  selectedQuarter: any;
  monthYearForLabel: any;
  sMonth: any;
  monthYearForPreviousLabel: any;
  chartFoundBool: boolean = false;
  headerFacilityImprovefacilityList: any = [];
  isCompare: boolean = false;
  totalFacilityComulativeDataRecord: number = 0;
  activationEMSTotalRecords: number = 0;
  activationEMSTimeCasesMaximum: number = 0;
  activationEMSTimeCasesMean: number = 0;
  activationEMSTimeCasesMedian: number = 0;
  activationTriageTotalRecords: number = 0;
  activationTriageTimeCasesMaximum: number = 0;
  activationTriageTimeCasesMean: number = 0;
  activationTriageTimeCasesMedian: number = 0;
  assessmentEMSTotalRecords: number = 0;
  assessmentEMSTimeCasesMaximum: number = 0;
  assessmentEMSTimeCasesMean: number = 0;
  assessmentEMSTimeCasesMedian: number = 0;
  assessmentTriageTotalRecords: number = 0;
  assessmentTriageTimeCasesMaximum: number = 0;
  assessmentTriageTimeCasesMean: number = 0;
  assessmentTriageTimeCasesMedian: number = 0;
  thrombolyticDecisionEMSTotalRecords: number = 0;
  thrombolyticDecisionEMSTimeCasesMaximum: number = 0;
  thrombolyticDecisionEMSTimeCasesMean: number = 0;
  thrombolyticDecisionEMSTimeCasesMedian: number = 0;
  thrombolyticDecisionTriageTimeCasesMedian: number = 0;
  thrombolyticDecisionTriageTimeCasesMean: number = 0;
  thrombolyticDecisionTriageTimeCasesMaximum: number = 0;
  thrombolyticDecisionTriageTotalRecords: number = 0;
  thrombolyticAdministrationEMSTotalRecords: number = 0;
  thrombolyticAdministrationEMSTimeCasesMaximum: number = 0;
  thrombolyticAdministrationEMSTimeCasesMean: number = 0;
  thrombolyticAdministrationEMSCasesMedian: number = 0;
  thrombolyticAdministrationTriageTotalRecords: number = 0;
  thrombolyticAdministrationTriageTimeCasesMaximum: number = 0;
  thrombolyticAdministrationTriageTimeCasesMean: number = 0;
  thrombolyticAdministrationTriageTimeCasesMedian: number = 0;
  activationTotalRecords: any;
  assessmentTotalRecords: any;
  thrombolyticDecisionTotalRecords: any;
  thrombolyticAdministrationTotalRecords: any;
  activationTgTotalRecords: any;
  assessmentTgTotalRecords: any;
  thrombolyticDecisionTgTotalRecords: any;
  thrombolyticAdministrationTgTotalRecords: any;
  assessmentTimeListQualifyCountInpatient: any;
  assessmentTotalInpatientRecords: any;
  assessmentInpatientTimeCasesMaximum: any;
  assessmentInpatientTimeCasesMean: any;
  assessmentInpatientTimeCasesMedian: any;
  assessmentTotalTriageRecords: any;
  assessmentTimeListQualifyCountEDOnset: any;
  assessmentTotalEDOnsetRecords: any;
  assessmentEDOnsetTimeCasesMaximum: any;
  assessmentEDOnsetTimeCasesMean: any;
  assessmentEDOnsetTimeCasesMedian: any;
  thrombolyticDecisionTimeListQualifyCountInpatient: any;
  thrombolyticDecisionTotalInpatientRecords: any;
  thrombolyticDecisionInpatientTimeCasesMaximum: any;
  thrombolyticDecisionInpatientTimeCasesMean: any;
  thrombolyticDecisionInpatientTimeCasesMedian: any;
  thrombolyticDecisionTotalTriageRecords: any;
  thrombolyticDecisionTimeListQualifyCountEDOnset: any;
  thrombolyticDecisionEDOnsetRecords: any;
  thrombolyticDecisionEDOnsetTimeCasesMaximum: any;
  thrombolyticDecisionEDOnsetTimeCasesMean: any;
  thrombolyticDecisionEDOnsetTimeCasesMedian: any;
  thrombolyticAdministrationTimeListQualifyCountInpatient: any;
  thrombolyticAdministrationTotalInpatientRecords: any;
  thrombolyticAdministrationInpatientTimeCasesMaximum: any;
  thrombolyticAdministrationInpatientTimeCasesMean: any;
  thrombolyticAdministrationInpatientTimeCasesMedian: any;
  thrombolyticAdministrationTotalTriageRecords: any;
  thrombolyticAdministrationTimeListQualifyCountEDOnset: any;
  thrombolyticAdministrationTotalEDOnsetRecords: any;
  thrombolyticAdministrationEDOnsetTimeCasesMaximum: any;
  thrombolyticAdministrationEDOnsetTimeCasesMean: any;
  thrombolyticAdministrationEDOnsetTimeCasesMedian: any;
  rapidiObj: any = {};
    stylesForData1: any = [];
  styleBool: boolean = false;
  stylesForData2: any = [];
  stylesForData3: any = [];
  stylesForCumlative1: any = [];
  stylesForCumlative2: any = [];
  boolForThrombolytic: boolean = false;
  administratedCheckData1Bool: boolean = false;
  administratedCheckData2Bool: boolean = false;
  administratedCheckData3Bool: boolean = false;
  IsEmsOrInPatientBoolNewObj: any = [];
  administratedCheckComulative1Bool: boolean = false;
  administratedCheckComulative2Bool: boolean = false;
  IsEmsOrInPatData1Bool: boolean = false;
  IsEmsOrInPatData2Bool: boolean = false;
  IsEmsOrInPatData3Bool: boolean = false;
  IsEmsOrInPatComulative1Bool: boolean = false;
  IsEmsOrInPatComulative2Bool: boolean = false;
  constructor(private improveService: ImproveService) { }

  ngOnInit(): void {
    this.graphImages = [];
    this.improveService._improveComponent.ReportTemplateComponent = this;
    this.basicData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
          {
              label: 'My First dataset',
              backgroundColor: '#42A5F5',
              data: [65, 59, 80, 81, 56, 55, 40]
          },
          {
              label: 'My Second dataset',
              backgroundColor: '#FFA726',
              data: [28, 48, 40, 19, 86, 27, 90]
          }
      ]
  };
    this.monthYear = this.improveService._improvePiFilterObj.monthYear
    this.selectedOptionText = this.improveService._improvePiFilterObj.selectedOptionText;

    this.bodyFacilityImprovefacilityList = this.improveService._improvePiFilterObj.reportDataObject;
    this.headerFacilityImprovefacilityList = this.improveService._improvePiFilterObj.reportHeaderObject;

    this.cumulativeYear = this.improveService._improvePiFilterObj.cumulativeYear
    this.pastcumulativeYear = this.improveService._improvePiFilterObj.pastcumulativeYear;
    if(this.improveService._improvePiFilterObj.qti_accomplishments_improvements){
    this.qti_accomplishments_improvements = this.improveService._improvePiFilterObj.qti_accomplishments_improvements.replace(/</g, "&lt;").replaceAll('\n', '<br>');
    }
    if(this.improveService._improvePiFilterObj.qti_opportunities_pi_projects){
      this.qti_opportunities_pi_projects = this.improveService._improvePiFilterObj.qti_opportunities_pi_projects.replace(/</g, "&lt;").replaceAll('\n', '<br>');
    }
    this.graphImages = this.improveService._improvePiFilterObj.graphImages;
    this.chartFoundBool = this.improveService._improvePiFilterObj.chartFoundBool;
    this.IsEmsOrInPatientBoolNewObj = this.improveService._improvePiFilterObj.IsEmsOrInPatientBoolNewObj;

/*  for summary */
    this.selectedFilterType = this.improveService._improvePiFilterObj.selectedFilterType

    this.headingSummaryOportunity = this.improveService._improvePiFilterObj.headingSummaryOportunity
    this.improveAHAAHASFL = this.improveService._improvePiFilterObj.improveAHAAHASFL
    this.improveAHAAHASFL2 = this.improveService._improvePiFilterObj.improveAHAAHASFL2
    this.activationToNeedleArray = this.improveService._improvePiFilterObj.activationToNeedleArray
    this.improveAData = this.improveService._improvePiFilterObj.improveAData
    this.improveAAData = this.improveService._improvePiFilterObj.improveAAData
    this.improveNData = this.improveService._improvePiFilterObj.improveNData
    this.improveATData = this.improveService._improvePiFilterObj.improveATData
    this.improveTAMHATS = this.improveService._improvePiFilterObj.improveTAMHATS

    this.stylesForData1 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.data1) || val[0]?.data1 === '-1%');
    this.stylesForData2 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.data2) || val[0]?.data2 === '-1%');
    this.stylesForData3 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.data3) || val[0]?.data3 === '-1%');
    this.stylesForCumlative1 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.cumlative1) || val[0]?.cumlative1 === '-1%');
    this.stylesForCumlative2 = this.bodyFacilityImprovefacilityList.filter((val:any) => !/[1-9]/.test(val[0]?.cumlative2) || val[0]?.cumlative2 === '-1%');
    this.boolForThrombolytic = false;
    this.administratedCheckData1Bool = false;
    this.administratedCheckData2Bool = false;
    this.administratedCheckData3Bool = false;
    this.administratedCheckComulative1Bool = false;
    this.administratedCheckComulative2Bool = false;

    this.IsEmsOrInPatData1Bool = false;
    this.IsEmsOrInPatData2Bool = false;
    this.IsEmsOrInPatData3Bool = false;
    this.IsEmsOrInPatComulative1Bool = false;
    this.IsEmsOrInPatComulative2Bool = false;
    if(this.stylesForData1.length === 21){
      this.bodyFacilityImprovefacilityList.forEach((val:any) => {
        val[0].data1 = '';
      });
    }
    if(this.stylesForData2.length === 21){
      this.bodyFacilityImprovefacilityList.forEach((val:any) => {
        val[0].data2 = '';
      });
    }
    if(this.stylesForData3.length === 21){
      this.bodyFacilityImprovefacilityList.forEach((val:any) => {
        val[0].data3 = '';
      });
    }
    if(this.stylesForCumlative1.length === 21){
      this.bodyFacilityImprovefacilityList.forEach((val:any) => {
        val[0].cumlative1 = '';
      });
    }
    if(this.stylesForCumlative2.length === 21){
      this.bodyFacilityImprovefacilityList.forEach((val:any) => {
        val[0].cumlative2 = '';
      });
    }
    const clearDataByQuality = (stylesForData:any, dataNumber:any, type:any) => {
      this.bodyFacilityImprovefacilityList.forEach((val:any) => {
        if(type === 'data'){
          if ((val[0]?.quality === '% 10 Min or Less Activation (EMS)' || val[0]?.quality === '% 10 Min or Less Activation (PV)') && val[0]['data' + dataNumber] === '-1%'){
            val[0]['data' + dataNumber] = '';
          }
        }
        if(type === 'comulative'){
          if((val[0]?.quality === '% 10 Min or Less Activation (EMS)' || val[0]?.quality === '% 10 Min or Less Activation (PV)') && val[0]['cumlative1'] === '-1%'){
          val[0]['cumlative1'] = '';
          }
          if((val[0]?.quality === '% 10 Min or Less Activation (EMS)' || val[0]?.quality === '% 10 Min or Less Activation (PV)') && val[0]['cumlative2'] === '-1%'){
            val[0]['cumlative2'] = '';
          }
        }

          if (
                val[0]?.quality === 'Door to Needle Mean (Min:Sec)' ||
                val[0]?.quality === 'Door to Needle Median (Min:Sec)' ||
                val[0]?.quality === 'Activation to Needle Mean' ||
                val[0]?.quality === 'Activation to Needle Median' ||
                val[0]?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' ||
                val[0]?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
                val[0]?.quality === 'DTN equal to or less than 30 minutes (%)' ||
                val[0]?.quality === 'DTN equal to or less than 45 minutes (%)' ||
                val[0]?.quality === 'DTN equal to or less than 60 minutes (%)'
            ){
              if(type === 'data'){
                if(this.bodyFacilityImprovefacilityList[9][0]['data' + dataNumber] === '0'){
                  val[0]['data' + dataNumber] = '';
                }
              }
              if(type === 'comulative'){
                if(this.bodyFacilityImprovefacilityList[9][0]['cumlative' + dataNumber] === '0'){
                  val[0]['cumlative' + dataNumber] = '';
                }
              }

            } 

          if (val[0]?.quality === 'Door to Needle Mean (Min:Sec)' ||
          val[0]?.quality === 'Door to Needle Median (Min:Sec)' ||
          val[0]?.quality === 'DTN equal to or less than 30 minutes (%)' ||
          val[0]?.quality === 'DTN equal to or less than 45 minutes (%)' ||
          val[0]?.quality === 'DTN equal to or less than 60 minutes (%)') 
          {
            if(type === 'data'){
            if (this.IsEmsOrInPatientBoolNewObj[dataNumber] === 'False' && this.bodyFacilityImprovefacilityList[9][0]['data' + dataNumber] !== '0') {
              val[0]['data' + dataNumber] = '';
            }
          }
            if(type === 'comulative'){
              if(this.IsEmsOrInPatientBoolNewObj[4] === 'False' && this.bodyFacilityImprovefacilityList[9][0]['cumlative1'] !== '0'){
                val[0]['cumlative1'] = '';
              }
               if(this.IsEmsOrInPatientBoolNewObj[5] === 'False' && this.bodyFacilityImprovefacilityList[9][0]['cumlative2'] !== '0'){
                val[0]['cumlative2'] = '';
              }
             }
          }

      });
  }
  
  if (this.stylesForData1.length < 21 ) {
      clearDataByQuality.call(this, this.stylesForData1, 1, 'data');
  }
  
  if (this.stylesForData2.length < 21) {
      clearDataByQuality.call(this, this.stylesForData2, 2, 'data');
  }
  
  if (this.stylesForData3.length < 21) {
      clearDataByQuality.call(this, this.stylesForData3, 3, 'data');
  }

  if (this.stylesForCumlative1.length < 21) {
    clearDataByQuality.call(this, this.stylesForCumlative1, 1, 'comulative');
}

if (this.stylesForCumlative2.length < 21) {
    clearDataByQuality.call(this, this.stylesForCumlative2, 2, 'comulative');
}


this.rapidiObj = this.improveService._improvePiFilterObj.rapidiObj;
  }

  async exportPdf(btnLoader: any) {
  await drawDOM(document.getElementById("reportData") as HTMLElement, {
    paperSize: "auto",
    scale: 0.8,
    landscape: true,
    margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
    forcePageBreak: '.improveReport',

  }).then((group: Group) => {
    return exportPDF(group);
  })
    .then((dataUri) => {
      btnLoader.value = false
      saveAs(dataUri, "improveTemplate.pdf");
    });
  }

  async pdfBase64EmailMaterial() {

    let emailPdf:any
  await drawDOM(document.getElementById("reportData") as HTMLElement, {
    paperSize: "auto",
    scale: 0.8,
    landscape: false,
    margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
    forcePageBreak: '.improveReport',

  }).then((group: Group) => {
    return exportPDF(group);
  })
    .then((dataUri) => {
      emailPdf = dataUri
    });
    return emailPdf;
  }
  customSort(event: any) {
    if (this.isCompare) {
      event.data.reverse();
      this.isCompare = false;
    } else {
      event.data.sort((data1: any, data2: any) => {
        let value1 = data1[event.multiSortMeta[0].field];
        let value2 = data2[event.multiSortMeta[0].field];
        if (value1 < value2) { return -1; }
        if (value1 > value2) { return 1; }
        else { return 0; }
      });
    }
  }

  exportWord(){

    let DATA: any = document.getElementById('reportData')?.innerHTML;
     const blob = new Blob([DATA], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
     saveAs(blob, 'report.doc');
  }

  getStyle(subBodyFacilityList: any, type: string) {
    const style:any = {};
    if(type == 'data1'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data1R < subBodyFacilityList.goals1R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data1R > subBodyFacilityList.goals1R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
      if (this.stylesForData1.length === 21) {
        style['color'] = 'white';
        style['background'] = '#969696';
      }
    }else if(type == 'data2'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data2R < subBodyFacilityList.goals2R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data2R > subBodyFacilityList.goals2R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
      if (this.stylesForData2.length === 21) {
        style['color'] = 'white';
        style['background'] = '#969696';
      }
    }else if(type == 'data3'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data3R < subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.data3R > subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
      if (this.stylesForData3.length === 21) {
        style['color'] = 'white';
        style['background'] = '#969696';
      }
    }else if(type == 'data4'){
      if ((subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.cumlative1R < subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) || (!subBodyFacilityList?.quality?.includes('%') && subBodyFacilityList.cumlative1R > subBodyFacilityList.goals3R && !subBodyFacilityList?.quality?.includes('#')) ) {
        style['color'] = 'red';
        style['font-weight'] = 'bold';
      }
    }
 
    if(type === 'data1' && this.stylesForData1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && subBodyFacilityList?.data1 === '0'){
      this.administratedCheckData1Bool = true;
    }
    else if(type === 'data2' && this.stylesForData2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && subBodyFacilityList?.data2 === '0'){
      this.administratedCheckData2Bool = true;
    }
    else if(type === 'data3' && this.stylesForData3.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && subBodyFacilityList?.data3 === '0'){
      this.administratedCheckData3Bool = true;
    }
    else if(type === 'data4' && this.stylesForCumlative1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && subBodyFacilityList?.cumlative1 === '0'){
      this.administratedCheckComulative1Bool = true;
    }
    else if(type === 'data5' && this.stylesForCumlative2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && subBodyFacilityList?.cumlative2 === '0'){
      this.administratedCheckComulative2Bool = true;
    }

    if(type === 'data1' && this.stylesForData1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data1 !== '0' || subBodyFacilityList?.data1 !== '')){
      this.IsEmsOrInPatData1Bool = true;
    }
    else if(type === 'data2' && this.stylesForData2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data2 !== '0' || subBodyFacilityList?.data2 !== '')){
      this.IsEmsOrInPatData2Bool = true;
    }
    else if(type === 'data3' && this.stylesForData3.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.data3 !== '0' || subBodyFacilityList?.data3 !== '')){
      this.IsEmsOrInPatData3Bool = true;
    }
    else if(type === 'data4' && this.stylesForCumlative1.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.cumlative1 !== '0' || subBodyFacilityList?.cumlative1 !== '')){
      this.IsEmsOrInPatComulative1Bool = true;
    }
    else if(type === 'data5' && this.stylesForCumlative2.length < 21 && subBodyFacilityList?.quality === 'THROMBOLYTIC ADMINISTERED #' && (subBodyFacilityList?.cumlative2 !== '0' || subBodyFacilityList?.cumlative2 !== '')){
      this.IsEmsOrInPatComulative2Bool = true;
    }
    if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
    subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
    subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
    subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
    subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
    this.administratedCheckData1Bool && type === 'data1'){
      style['color'] = 'white';
      style['background'] = '#969696';
      }

      if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
      subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
      this.administratedCheckData2Bool && type === 'data2'){
        style['color'] = 'white';
        style['background'] = '#969696';
        }

      if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
      subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
      subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
      this.administratedCheckData3Bool && type === 'data3'){
        style['color'] = 'white';
        style['background'] = '#969696';
        }

        if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
        subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
        subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
        this.administratedCheckComulative1Bool && type === 'data4'){
          style['color'] = 'white';
          style['background'] = '#969696';
          }
          
  
        if((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
        subBodyFacilityList?.quality === 'Activation to Needle Mean' || subBodyFacilityList?.quality === 'Activation to Needle Median' ||
        subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') && 
        this.administratedCheckComulative2Bool && type === 'data5'){
          style['color'] = 'white';
          style['background'] = '#969696';
          }

        if ((subBodyFacilityList?.quality === 'Door to Needle Mean (Min:Sec)' || subBodyFacilityList?.quality === 'Door to Needle Median (Min:Sec)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 30 minutes (%)' || subBodyFacilityList?.quality === 'DTN equal to or less than 45 minutes (%)' ||
        subBodyFacilityList?.quality === 'DTN equal to or less than 60 minutes (%)') &&
        ((this.IsEmsOrInPatientBoolNewObj[1] == "False" && type === 'data1' && this.IsEmsOrInPatData1Bool) ||
        (this.IsEmsOrInPatientBoolNewObj[2] == "False" && type === 'data2' && this.IsEmsOrInPatData2Bool) ||
        (this.IsEmsOrInPatientBoolNewObj[3] == "False" && type === 'data3' && this.IsEmsOrInPatData3Bool) ||
        (this.IsEmsOrInPatientBoolNewObj[4] == "False" && type === 'data4' && this.IsEmsOrInPatComulative1Bool) ||
        (this.IsEmsOrInPatientBoolNewObj[5] == "False" && type === 'data5' && this.IsEmsOrInPatComulative2Bool))
       ) {
        style['color'] = 'white';
        style['background'] = '#969696';
      }

    return style;
  }
}
